import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Minimize } from '@material-ui/icons';
import { FaPlus, FaMinus } from "react-icons/fa";
import { ImPlus, ImMinus } from "react-icons/im";

const MiCollectionAccordian = () => {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <>
      <div className='mi_collection_accordian_section'>
        <Container >
          <Row>
            <Col sm={12} md={12} lg={12} className='p-0'>
              <div className='mi_Accor_box'>
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} className='mi_Accordian_col'>
                  <AccordionSummary
                    expandIcon={expanded === 'panel1' ? <ImMinus /> : <ImPlus />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className='mi_collection_accordian_summery'
                  >
                    <Typography className='mi_collection_Accordian_heading'>
                      Popular Diamond Collections
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className='mi_collection_Accordian_subheading'>
                      Lorem Ipsum is simply dummy text    Lorem Ipsum is simply dummy text Lorem Ipsum is simply dummy text
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} className='mi_Accordian_col'>
                  <AccordionSummary
                    expandIcon={expanded === 'panel2' ? <ImMinus /> : <ImPlus />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                  >
                    <Typography className='mi_collection_Accordian_heading'>
                      Popular Ring Collections
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className='mi_collection_Accordian_subheading'>
                      Lorem Ipsum is simply dummy text Lorem Ipsum is simply dummy text Lorem Ipsum is simply dummy text
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')} className='mi_Accordian_col nomargin'>
                  <AccordionSummary
                    expandIcon={expanded === 'panel3' ? <ImMinus /> : <ImPlus />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                  >
                    <Typography className='mi_collection_Accordian_heading'>
                      Popular jewelry Collections
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className='mi_collection_Accordian_subheading'>
                      Lorem Ipsum is simply dummy text Lorem Ipsum is simply dummy text Lorem Ipsum is simply dummy text
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default MiCollectionAccordian
